import * as R from 'ramda';

function setFilesValueHandler({ files, form, name }) {
  const { change } = form;
  return (prevFiles) => {
    if (R.equals(prevFiles, files)) return;
    change(`${name}.files`, files);
  };
}

export { setFilesValueHandler as setFilesValue };
